import React from "react";

import "./index.css";

const Error = ({ message }) => <h4 className="error">{message}</h4>;

export default Error;
